/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    TERMINATED: 'terminated',
    DELETED: 'deleted',
    UNREGISTERED: 'unregistered',
};
